export const Users = [
  {
    id: 1,
    profilePicture: "person/11.jpg",
    username: "Mark Twen",
  },
  {
    id: 2,
    profilePicture: "person/2.jpg",
    username: "Janell Shrum",
  },
  {
    id: 3,
    profilePicture: "person/3.jpg",
    username: "Alex Durden",
  },
  {
    id: 4,
    profilePicture: "person/4.jpg",
    username: "Dora Howks",
  },
  {
    id: 5,
    profilePicture: "person/5.jpg",
    username: "Thomas Holden",
  },
  {
    id: 6,
    profilePicture: "person/6.jpg",
    username: "Travis Bannet",
  },
  {
    id: 7,
    profilePicture: "person/7.jpg",
    username: "Shirley Beauchamp",
  },
  {
    id: 8,
    profilePicture: "person/8.jpg",
    username: "Kristen Thomas",
  },
  {
    id: 9,
    profilePicture: "person/9.jpg",
    username: "Gary Duty",
  },
  {
    id: 10,
    profilePicture: "person/10.jpg",
    username: "Safak Kocaoglu",
  },
];

export const Posts = [
  {
    id: 1,
    desc: "Love for All, Hatred for none",
    photo: "others/birds.jpg",
    date: "5 mins ago",
    userId: 1,
    like: 32,
    comment: 9,
  },
  {
    id: 2,
    desc: "A book is a medium for recording information in the form of writing or images",
    photo: "others/book.jpg",
    date: "2 mins ago",
    userId: 2,
    like: 65,
    comment: 28,
  },
  {
    id: 3,
    desc: " The technical term for this physical arrangement is codex",
    photo: "others/flower-tulip.jpg",
    date: "25 mins ago",
    userId: 3,
    like: 2,
    comment: 9,
  },
  {
    id: 4,
    desc: "Search the world's most comprehensive index of full-text books",
    photo: "others/winter-quote.jpg",
    date: "2 hours ago",
    userId: 4,
    like: 14,
    comment: 6,
  },
  {
    id: 5,
    desc: "New line add can prove that day is the best one",
    photo: "others/madrasah.jpg",
    date: "10 mins ago",
    userId: 5,
    like: 62,
    comment: 25,
  },
  {
    id: 6,
    desc: "Can you solve this problem or can't you solve this problem?",
    photo: "others/nikah.jpg",
    date: "35 mins ago",
    userId: 6,
    like: 35,
    comment: 14,
  },
  {
    id: 7,
    desc: "How to write the text thext even you don't know where it is coming from",
    photo: "others/takhir.jpg",
    date: "9 mins ago",
    userId: 7,
    like: 43,
    comment: 19,
  },
  {
    id: 8,
    desc: "Just make risk, it will done automatically",
    photo: "others/squirrel.jpg",
    date: "4 mins ago",
    userId: 8,
    like: 4,
    comment: 0,
  },
  {
    id: 9,
    desc: "Have you written any book in your whole life?",
    photo: "others/success.jpg",
    date: "15 mins ago",
    userId: 9,
    like: 12,
    comment: 1,
  },
  {
    id: 10,
    desc: "This is a book about Harry Potter and the sorcerer's stone",
    photo: "others/owl.jpg",
    date: "1 hours ago",
    userId: 10,
    like: 16,
    comment: 3,
  },
];
